import Vue from 'vue'
import axios from '@/util/axios'
import PortalVue from 'portal-vue'
// import VueCookie from 'vue-cookie';

// Retina Js
// import VueLazyload from "vue-lazyload";

Vue.use(PortalVue)
// Vue.use(VueCookie);
// Vue.use(VueLazyload)

// Vue.prototype.$route = window.route

export default class Website {

    constructor(config) {
        this.bus = new Vue()
        this.config = config

        // moment.locale(config.locale);

        Vue.prototype.$authUser = config.user

        // Debug
        Vue.config.debug = config.debug;
        Vue.config.devtools = config.debug;
    }

    /**
     * Start the Nova app by calling each of the tool's callbacks and then creating
     * the underlying Vue instance.
     */
    liftOff() {
        this.app = new Vue({
            el: '#well-traveled-app',
            mounted() {
                document.getElementById('loadingContent').remove()
            }
        })
    }

    /**
     * Return an axios instance configured to make requests to Nova's API
     * and handle certain response codes.
     */
    request(options) {
        if (options !== undefined) {
            return axios(options)
        }

        return axios
    }

    /**
     * Check if the enviroment name given is the same as the configuration.
     */
    env(name){
        return this.config.enviroment == name
    }

    /**
     * Register a listener on Nova's built-in event bus
     */
    $on(...args) {
        this.bus.$on(...args)
    }

    /**
     * Register a one-time listener on the event bus
     */
    $once(...args) {
        this.bus.$once(...args)
    }

    /**
     * Unregister an listener on the event bus
     */
    $off(...args) {
        this.bus.$off(...args)
    }

    /**
     * Emit an event on the event bus
     */
    $emit(...args) {
        this.bus.$emit(...args)
    }
}
